export * from './base-service'
export * from './profile.service'
export * from './faculty.service'
export * from './queue.service'
export * from './registration.service'
export * from './issue.service'
export * from './time-table-fixed.service'
export * from './service-provider.module'
export * from './user.service'
export * from './login.service'
export * from './account.service'
export * from './principal.service'
export * from './user-route-access-service'
export * from './software-inventory.service'



// WEBPACK FOOTER //
// ./src/main/webapp/app/services/index.ts